<script>
export default {
    components: {},
    computed: {},
    watch: {},
    data() {
        return {}
    },
    methods: {},
}
</script>

<template>
    <div>
        <h4>{{ $appConfig('APEX_CLUB_NAME', 'Apex Club') }} Abonnement</h4>
        <p>Entfesseln Sie Ihren inneren Rennfahrer mit unserem {{ $appConfig('APEX_CLUB_NAME', 'Apex Club') }} Abonnementplan! <strong>Erhalten Sie bis zu 50% Rabatt, wenn Sie sich anmelden</strong> für monatliches Guthabenaufladen—bedeutet mehr Zeit hinter dem Lenkrad für weniger. Guthaben können verwendet werden, um unsere ultra-realistischen, hochwertigen Rennsimulatoren zu buchen, perfekt für Sie und Ihre Freunde. Von der Formel 1 bis zum GT-Rennen bieten unsere Setups ein vollständig immersives Erlebnis mit Haptic Motion Feedback.</p>
        <h4>FAQ</h4>
        <p>
            <ul>
                <li><strong>Wie funktioniert das Abonnement?</strong> Sie kaufen Guthaben zu einem ermäßigten Preis, bis zu 50% Rabatt!</li>
                <li><strong>Kann ich Guthaben für Freunde verwenden?</strong> Ja, teilen Sie das Erlebnis, indem Sie für andere buchen.</li>
                <li><strong>Laufen Guthaben ab?</strong> Ja, nutzen oder verlieren!</li>
                <li><strong>Welche Simulatoren kann ich nutzen?</strong> Sie können Guthaben für jeden Simulator verwenden. Sie wählen einfach die Menge an Guthaben, die Sie jeden Monat auffüllen möchten.</li>
                <li><strong>Wie lange muss ich mein Abonnement aktiv halten?</strong> Wenn Sie Ihr Abonnement innerhalb von 2 Monaten kündigen, wird Ihnen der volle Preis für die von Ihnen vorgenommenen Reservierungen berechnet.</li>
            </ul>
        </p>
    </div>
</template>

<style lang="scss" scoped>
</style>
